export enum TestIds {
    MAIN_BANNER_HEADER_CTA_DESKTOP = "main-banner-header-cta-desktop",
    MAIN_BANNER_HEADER_CTA_MOBILE = "main-banner-header-cta-mobile",
    ADVANTAGES_WITH_HEADING_CTA = "advantages-with-heading-cta",
    QUESTIONS_WITH_IMAGE_CTA = "questions-with-image-cta",
    MAP_CLINIC_CARD_CTA = "map-clinic-card-cta",
    MOBILE_MENU_FIRST_CTA = "mobile-menu-first-cta",
    MOBILE_MENU_SECOND_CTA = "mobile-menu-second-cta",
    MOBILE_MENU_HAMBURGER = "mobile-menu-hamburger",
    LEAD_FORM_TITLE = "lead-from-title",
}
